import React from 'react';
import AboutUsSection from '../components/AboutUsSection';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <div className="about-container">
        <AboutUsSection />
      </div>
    </div>
  );
}

export default About;


